import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFound.module.css';

export default function NotFound() {
  return (
    <div className={styles.notfound}>
      <div className="background" />

      <div className={styles.overlay} />

      <div className={styles.container}>
        <h1 className={styles.errorCode}>404</h1>

        <div className={styles.message}>
          <p className={styles.mainText}>Трибут, ты забрёл за пределы Арены...</p>
          <p className={styles.subText}>
            Эта территория не входит в зону Голодных Игр.
            <br />
            Похоже, тебя здесь не ждали.
          </p>
        </div>

        <Link to="/hunger-games" className={styles.homeButton}>
          <span>Вернуться в безопасную зону</span>
        </Link>

        <p className={styles.easterEgg}>
          P.S. Говорят, где-то здесь спрятан секретный сундук...
        </p>
      </div>

      <div className={styles.particles}>
        {[...Array(6)].map((_, i) => (
          <span key={i} style={{ '--i': i } as React.CSSProperties} />
        ))}
      </div>
    </div>
  );
}
